<template>
	<div
		class="g-block-qrcode-nav-card"
		:class="{
			'g-block-qrcode-nav-card--edit': editable,
			'is-active': editable && active,
			'g-block-qrcode-nav-card--h5': h5,
		}"
		:style="cardStyle"
		@click="onWrapClick"
	>
		<div class="g-block-qrcode-nav-card__header">
			<div v-if="showImage" class="g-block-qrcode-nav-card__thumb">
				<img v-if="imageUrl" :src="imageUrl" alt="" />
				<i v-else class="mbm-iconfont mbm-tupian"></i>
			</div>
			<div class="g-block-qrcode-nav-card__title" :style="{ color: titleColor }">{{ title }}</div>
		</div>
		<div class="g-block-qrcode-nav-card__desc" :style="{ color: detailColor }">{{ description }}</div>
		<div class="g-block-qrcode-nav-card__footer">
			<div class="g-block-qrcode-nav-card__divider"></div>
			<div class="g-block-qrcode-nav-card__action" :style="{ color: detailColor }">{{ actionText }}</div>
		</div>
	</div>
</template>

<script>
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import {
		getQrcodeNavCardStyle,
		getQrcodeNavImageUrl,
		normalizeQrcodeNavData,
		QRCODE_NAV_TYPES,
	} from '../../../utils/qrcodeNav.js';

	export default {
		name: 'GQrcodeNavCardShell',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			normalizedData() {
				return normalizeQrcodeNavData(QRCODE_NAV_TYPES.card, this.data);
			},
			showImage() {
				return this.normalizedData.showImage !== false;
			},
			title() {
				return this.normalizedData.title;
			},
			description() {
				return this.normalizedData.description;
			},
			actionText() {
				return this.normalizedData.actionText;
			},
			titleColor() {
				return this.normalizedData.titleColor;
			},
			detailColor() {
				return this.normalizedData.detailColor;
			},
			imageUrl() {
				return getQrcodeNavImageUrl(this.normalizedData.image);
			},
			cardStyle() {
				return getQrcodeNavCardStyle(QRCODE_NAV_TYPES.card, this.data, { h5: this.h5 });
			},
		},
		methods: {
			onWrapClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.h5 && this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-qrcode-nav-card {
		padding: 14px 16px 12px;
		background: #fff;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
		cursor: default;

		&--edit {
			border: 1px solid transparent;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15), 0 2px 12px rgba(0, 0, 0, 0.08);
			}
		}

		&--h5 {
			padding: 0.28rem 0.32rem 0.24rem;
		}
	}

	.g-block-qrcode-nav-card__header {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 12px;

		.g-block-qrcode-nav-card--h5 & {
			gap: 0.2rem;
			margin-bottom: 0.24rem;
		}
	}

	.g-block-qrcode-nav-card__thumb {
		flex-shrink: 0;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 16px;
			color: #bfbfbf;
		}

		.g-block-qrcode-nav-card--h5 & {
			width: 0.72rem;
			height: 0.72rem;

			i {
				font-size: 0.32rem;
			}
		}
	}

	.g-block-qrcode-nav-card__title {
		flex: 1;
		min-width: 0;
		font-size: 16px;
		font-weight: 600;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-qrcode-nav-card--h5 & {
			font-size: 0.32rem;
		}
	}

	.g-block-qrcode-nav-card__desc {
		font-size: 13px;
		line-height: 1.7;
		word-break: break-word;

		.g-block-qrcode-nav-card--h5 & {
			font-size: 0.26rem;
		}
	}

	.g-block-qrcode-nav-card__footer {
		margin-top: 14px;

		.g-block-qrcode-nav-card--h5 & {
			margin-top: 0.28rem;
		}
	}

	.g-block-qrcode-nav-card__divider {
		height: 1px;
		background: #f0f0f0;
		margin-bottom: 10px;

		.g-block-qrcode-nav-card--h5 & {
			margin-bottom: 0.2rem;
		}
	}

	.g-block-qrcode-nav-card__action {
		text-align: right;
		font-size: 13px;
		line-height: 1.4;

		.g-block-qrcode-nav-card--h5 & {
			font-size: 0.26rem;
		}
	}
</style>
